var _path, _g, _path2, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    fill: "none",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12z",
    fill: "#0052b4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f0f0f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0h0zm-.032 12H12v-.032l-.032.032z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.262L11.998.001C5.372.002 0 5.374 0 12.001h6.261V8.475l3.526 3.526h2.181l.032-.032V9.787L8.474 6.262H12z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.071 1.565a12.06 12.06 0 0 0-4.506 4.506V12h3.13V4.696H12v-3.13H6.071zM12 10.524L7.737 6.261H6.261L12 12v-1.476z",
    fill: "#d80027"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f0f0f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.237 14.087l.659 1.377 1.487-.344-.666 1.374 1.196.948-1.489.336.004 1.526-1.191-.955-1.191.955.004-1.526-1.489-.336 1.196-.948-.666-1.373 1.487.344.659-1.377z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.903 9.391l.329.689.744-.172-.333.687.598.474-.745.168.002.763-.595-.477-.595.477.002-.763-.744-.168.598-.474-.333-.687.744.172.329-.689z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: -11.479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.642 8.348l.329.689.744-.172-.333.687.598.474-.744.168.002.763-.595-.478-.595.478.002-.763-.744-.168.598-.474-.333-.687.743.172.329-.689zM18.729 12l.259.797h.838l-.678.493.259.797-.678-.493-.678.493.259-.797-.678-.493h.838l.259-.797z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M17.966 16.696l.329.689.744-.172-.333.687.598.474-.745.168.002.763-.595-.478-.595.478.002-.763-.745-.168.598-.474-.333-.687.744.172.329-.689z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAud);
export default __webpack_public_path__ + "static/media/aud.37c8f75a56d7ae281dfa4c806830d9ab.svg";
export { ForwardRef as ReactComponent };